import { ChangeDetectorRef, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
// Layout
import {
  LayoutConfigService,
  MenuConfigService,
  MenuHorizontalService,
  PageConfigService
} from '../../../core/_base/layout';
import { HtmlClassService } from '../html-class.service';
import { LayoutConfig } from '../../../core/_config/layout.config';
import { MenuConfig } from '../../../core/_config/menu.config';
import { PageConfig } from '../../../core/_config/page.config';
import { Observable, Subscription } from 'rxjs';
import { currentUserPermissions, Permission } from '@app/core/auth';
import { AppState } from '@app/core/reducers';
import { select, Store } from '@ngrx/store';
import { NgxPermissionsService } from 'ngx-permissions';
// Object-Path
import * as objectPath from 'object-path';
import { HeaderComponent } from '../header/header.component';
import { NotificationService } from '@app/api/notification.service';
import { NotificationStateService } from '@app/services/notification-state.service';
import { SignalRService } from '@app/services/signalr.service';
import { AuthService, isLoggedIn } from '@app/core/auth';

@Component({
  selector: 'meu-base-admin',
  templateUrl: './base-admin.component.html',
  styleUrls: ['./base-admin.component.scss'],
  providers: [NotificationStateService]
})
export class BaseAdminComponent implements OnInit {
  @ViewChild('ktHeaderLayout', { static: false }) ktHeaderLayout: HeaderComponent;
  // Public variables
  selfLayout: string;
  asideDisplay: boolean;
  asideSecondary: boolean;
  subheaderDisplay: boolean;
  fluid: boolean;
  unreadNotifications: any[] = [];
  unreadCount: number = 0;

  // Private properties
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  private currentUserPermissions$: Observable<Permission[]>;
  constructor(
    private layoutConfigService: LayoutConfigService,
    private menuConfigService: MenuConfigService,
    private pageConfigService: PageConfigService,
    private htmlClassService: HtmlClassService,
    private store: Store<AppState>,
    private permissionsService: NgxPermissionsService,
    private menuHozitalService: MenuHorizontalService,
    private notificationService: NotificationService,
    private notificationStateService: NotificationStateService,
    private signalRService: SignalRService,
    private cdr: ChangeDetectorRef
  ) {
    this.loadRolesWithPermissions();

    // register configs by demos
    this.layoutConfigService.loadConfigs(new LayoutConfig().configs);
    this.menuConfigService.loadConfigs(new MenuConfig().configs);
    this.pageConfigService.loadConfigs(new PageConfig().configs);

    // setup element classes
    this.htmlClassService.setConfig(this.layoutConfigService.getConfig());

    const subscr = this.layoutConfigService.onConfigUpdated$.subscribe((layoutConfig) => {
      // reset body class based on global and page level layout config, refer to html-class.service.ts
      document.body.className = '';
      this.htmlClassService.setConfig(layoutConfig);
    });
    this.unsubscribe.push(subscr);
  }
  ngOnInit() {
    const config = this.layoutConfigService.getConfig();
    this.selfLayout = objectPath.get(config, 'self.layout');
    this.asideDisplay = objectPath.get(config, 'aside.self.display');
    this.subheaderDisplay = objectPath.get(config, 'subheader.display');
    this.fluid = objectPath.get(config, 'content.width') === 'fluid';

    // let the layout type change
    const subscr = this.layoutConfigService.onConfigUpdated$.subscribe((cfg) => {
      setTimeout(() => {
        this.selfLayout = objectPath.get(cfg, 'self.layout');
      });
    });
    this.unsubscribe.push(subscr);
    this.menuHozitalService.hideMenu();
    this.loadUnreadNotifications();
    this.startSignalR();
  }

  /**Initialize a SignalR connection to receive real-time notifications*/
  private startSignalR() {
    // Connect only when the user is logged in
    const token = localStorage.getItem('authce9d77b308c149d5992a80073637e4d5');
    if (token && token.length > 10) {
      this.signalRService.start();
    }
    // Listen for login status changes to start/stop SignalR
    const loginSub = this.store.pipe(select(isLoggedIn)).subscribe((loggedIn) => {
      if (loggedIn) {
        this.signalRService.start();
      } else {
        this.signalRService.stop();
      }
    });
    this.unsubscribe.push(loginSub);
  }
  loadUnreadNotifications() {
    const filter = 'read==false,summary==Đơn hàng mới';
    this.notificationService.apiNotificationGet(filter, '', 1, 100).subscribe((res) => {
      if (res.success) {
        const ids = res.data.collection
          .map((n) => {
            return n.reference_link ? n.reference_link.split('/').pop() : null;
          })
          .filter((id) => id !== null);
        this.notificationStateService.updateUnreadIds(ids);
        this.unreadCount = res.data.total;
        this.cdr.detectChanges();
      }
    });
  }
  ngOnDestroy(): void {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
  loadRolesWithPermissions() {
    this.currentUserPermissions$ = this.store.pipe(select(currentUserPermissions));
    const subscr = this.currentUserPermissions$.subscribe((res) => {
      if (!res || res.length === 0) {
        return;
      }

      this.permissionsService.flushPermissions();
      res.forEach((pm: Permission) => this.permissionsService.addPermission(pm.name));
    });
    this.unsubscribe.push(subscr);
  }
}
